// export const SERVER_API_URL = "http://3.105.6.139:5000";
// export const SERVER_API_URL = "http://localhost:5000";
// export const SERVER_API_URL = "http://13.55.69.12:5000";  // server ccl magic
export const SERVER_API_URL = process.env.SERVER_API_URL;

export const AVATAR_DEFAULT = "//www.gravatar.com/avatar/4d317e9d4140af19a6d6b0b55fc68b7b?s=200&r=pg&d=mm";

export const AUTHORITIES = {
    ADMIN: 'ROLE_ADMIN',
    FREE_USER: 'ROLE_FREE_USER',
    SUBSCRIPTION_USER: 'ROLE_SUBSCRIPTION_USER'
};

export const ANIMATION_IN = 'fadeInRight';
export const ANIMATION_OUT = 'fadeOutLeft';